import { useGet } from '../useGet';
import { API_URL } from '~/utils';

export function useObterCompromissosPorDia() {
  return useGet({
    url: `${API_URL}/compromissos/obter-compromissos-por-dia`,
    config: {
      getAccessToken: true,
      timeout: 120000,
    },
  });
}
